import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IPlant } from "interfaces/plant";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PLANT" }
);

export interface ListPlantState extends IState {
  data: IPlant[];
}

interface ISuccessListPlantAction extends ISuccessAction {
  data: IPlant[];
}

const INITIAL_STATE: ListPlantState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPlantState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListPlantState, action: ISuccessListPlantAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPlantState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPlant = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPlantTypes = Types;
export const ListPlantActions = Creators;
